var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_0_2566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2759 4.1377H35.3071V0.856445H32.0259V4.1377H10.3696V0.856445H7.08838V4.1377H5.11963C2.40571 4.1377 0.197754 6.34565 0.197754 9.05957V37.9346C0.197754 40.6485 2.40571 42.8564 5.11963 42.8564H37.2759C39.9898 42.8564 42.1978 40.6485 42.1978 37.9346V9.05957C42.1978 6.34565 39.9898 4.1377 37.2759 4.1377ZM38.9165 37.9346C38.9165 38.8392 38.1805 39.5752 37.2759 39.5752H5.11963C4.21499 39.5752 3.479 38.8392 3.479 37.9346V16.2783H38.9165V37.9346ZM38.9165 12.9971H3.479V9.05957C3.479 8.15493 4.21499 7.41895 5.11963 7.41895H7.08838V10.7002H10.3696V7.41895H32.0259V10.7002H35.3071V7.41895H37.2759C38.1805 7.41895 38.9165 8.15493 38.9165 9.05957V12.9971Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43213 19.7236H9.71338V23.0049H6.43213V19.7236ZM12.9946 19.7236H16.2759V23.0049H12.9946V19.7236ZM19.5571 19.7236H22.8384V23.0049H19.5571V19.7236ZM26.1196 19.7236H29.4009V23.0049H26.1196V19.7236ZM32.6821 19.7236H35.9634V23.0049H32.6821V19.7236ZM6.43213 26.2861H9.71338V29.5674H6.43213V26.2861ZM12.9946 26.2861H16.2759V29.5674H12.9946V26.2861ZM19.5571 26.2861H22.8384V29.5674H19.5571V26.2861ZM26.1196 26.2861H29.4009V29.5674H26.1196V26.2861ZM6.43213 32.8486H9.71338V36.1299H6.43213V32.8486ZM12.9946 32.8486H16.2759V36.1299H12.9946V32.8486ZM19.5571 32.8486H22.8384V36.1299H19.5571V32.8486ZM26.1196 32.8486H29.4009V36.1299H26.1196V32.8486ZM32.6821 26.2861H35.9634V29.5674H32.6821V26.2861Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.197754 0.856445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCalender);
export default __webpack_public_path__ + "static/media/GreyCalender.4c17e065e95b246313c647506dac61ea.svg";
export { ForwardRef as ReactComponent };